import React from 'react';
import styled from 'styled-components';
import { black, white, neutral800, IconSmallCloseLegacy } from '@prezi/common-design';
import { alpha, Title } from '../..';

export const ModalBackdrop = styled.div<{ zIndex?: number }>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${alpha(black, 0.4)};
    z-index: ${props => (props.zIndex !== undefined ? props.zIndex : 1)};
`;

export const ModalWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
`;

export const ModalBody = styled.div`
    background-color: ${white};
    box-shadow: 0 16px 48px ${alpha(neutral800, 0.32)}, 0 8px 16px ${alpha(neutral800, 0.24)},
        0 0px 0px ${alpha(black, 0.08)};
    border-radius: 4px;
`;

export const ModalTitle = styled(Title)`
    margin-bottom: 16px;
`;

export const ModalButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-top: 28px;
    margin: 0 -4px;

    button {
        margin: 0 4px;
    }
`;

export const ModalHeader = styled.header`
    padding: 16px 24px;
    border-bottom: 1px solid ${({ theme }) => theme.bento.colors.neutral.weak};
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ModalFooter = styled.footer`
    padding: 24px;
    border-top: 1px solid ${({ theme }) => theme.bento.colors.neutral.weak};
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ModalContent = styled.div`
    padding: 24px;
`;

const ModalCloseIcon = styled(IconSmallCloseLegacy)`
    cursor: pointer;
`;

export const ModalCloseButton: React.FC<{ onClick: () => void }> = props => <ModalCloseIcon {...props} />;
